import React, { useContext } from 'react';
import { Context } from '../../../store/reducer';

const Component = () => {
    const { dispatch } = useContext(Context);
    return (
        <header className="header is-nobg">
            <div className="h-back">
                <div className="gnav-back-inner">
                    <a href="#" onClick={()=>{
                        dispatch({type:'TOGGLE_MODE'})
                        dispatch({
                            type: 'SET_NEW_SPOT',
                            category: null,
                            latitude: null,
                            longitude: null,
                            name: null,
                            memo: null 
                        })
                        }}>
                        <span className="h-back-icon"></span><span className="h-back-txt">もどる</span>
                    </a>
                </div>
            </div>
            <div className="header-title is-only">
                <h1>スポットを登録</h1>
            </div>
        </header>
    )
}

export default Component;